import styled from 'styled-components';
import { lighten, darken } from 'polished';

interface TableContentProps {
  showHeader: boolean;
  rowIsClickable: boolean;
}

export const Search = styled.div`
  padding: 1px;
  border-radius: 100px;
  border: 1px solid #4a4b4b;
  background-color: #202020;

  input {
    margin: 5px 0;
    padding: 0 10px;
    border: none;
    border-radius: 100px;
    background-color: #202020;
    color: #606060 !important;
  }
`;

export const TableContent = styled.div<TableContentProps>`
  border-radius: 20px;
  overflow: hidden;
  background-color: #202020;

  .menu-table {
    z-index: 10;
    top: 55px;
    left: 15px;
    right: 15px;

    .search {
      padding: 1px;
      border-radius: 100px;

      input {
        margin: 10px 0;
        padding: 0 10px;
        border: none;
        border-radius: 100px;
        background-color: #202020;
      }
    }

    .inputDate {
      border: 1px solid #4a4b4b;
      background-color: transparent;
      color: #828282 !important;
      padding: 6px 10px;
      border-radius: 100px;
      text-align: center;
      font-weight: 300;
    }

    .btn-export:hover {
      border: 1px solid ${lighten(0.1, '#4a4b4b')}!important;
      img {
        filter: brightness(1.5) !important;
      }
    }
  }

  div.tableData {
    .rdt_TableHeader {
      display: ${(props) => (props.showHeader ? 'block' : 'none')};
    }

    div {
      background-color: #202020;
    }

    .rdt_TableRow {
      padding: 5px 0;
      cursor: ${(props) => (props.rowIsClickable ? 'pointer' : 'default')};
      transition-duration: 0.3s;

      div {
        transition-duration: 0.3s;
      }

      :hover {
        background-color: ${darken(0.03, '#202020')};

        div {
          background-color: ${darken(0.03, '#202020')};
        }
      }
    }
  }

  @media screen and (max-width: 1399px) {
    div.tableData {
      max-width: 1200px;
    }
  }

  @media screen and (max-width: 400px) {
    .inputDate {
      font-size: 13px;
      padding: 7px 10px !important;
      img {
        width: 16px;
      }
    }
  }
`;

export const Pagination = styled.div`
  p,
  button {
    color: #828282 !important;
  }

  button {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    font-weight: bold;

    :first-child,
    :last-child {
      width: auto;
      border-radius: 5px;
    }
  }

  button.active,
  button:hover {
    background: #3f3f3f !important;
    color: #dadada !important;
  }
`;
